import { render, staticRenderFns } from "./MatterRealizationScopes.vue?vue&type=template&id=211d7800&scoped=true"
import script from "./MatterRealizationScopes.vue?vue&type=script&setup=true&lang=js"
export * from "./MatterRealizationScopes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MatterRealizationScopes.vue?vue&type=style&index=0&id=211d7800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211d7800",
  null
  
)

export default component.exports